import {
  createRootRoute,
  Outlet,
  retainSearchParams,
} from '@tanstack/react-router';
import { useAuthStore } from '@features/auth';
import { DialogsProvider } from '@toolpad/core/useDialogs';
import { z } from 'zod';
import { zodValidator } from '@tanstack/zod-adapter';

const searchSchema = z.object({
  venue: z.string().optional(),
  redirect: z.string().optional(),
});

export const Route = createRootRoute({
  validateSearch: zodValidator(searchSchema),
  search: {
    middlewares: [retainSearchParams(['venue'])],
  },
  beforeLoad: async ({ search }: { search: { venue?: string } }) => {
    if (search.venue) {
      useAuthStore.setState({ venueSlug: search.venue });
      console.log('beforeLoad venue', search.venue);
    } else {
      useAuthStore.setState({ venueSlug: undefined });
    }
  },
  component: () => {
    return (
      <DialogsProvider>
        <Outlet />
        {/* <TanStackRouterDevtools /> */}
      </DialogsProvider>
    );
  },
});
